import React from 'react';
import { IconType, SubPageNav as SubPageNavComponent } from '@sato/components';

import { Link } from '@components/common/Link';

import { ISubPageNav, ParsedEntry } from '../types';

export const SubPageNav = ({ data }: { data: ParsedEntry<ISubPageNav> }) => {
  const { leftButton, rightButton, showLogo } = data;

  return (
    <SubPageNavComponent
      showLogo={showLogo}
      leftButton={
        leftButton?.url
          ? {
              children: leftButton.text,
              icon: leftButton.icon?.icon as unknown as IconType,
              iconPosition: 'left',
              wrapperComponent: Link,
              to: leftButton.url,
            }
          : undefined
      }
      rightButton={
        rightButton?.url
          ? {
              children: rightButton.text,
              icon: rightButton.icon?.icon as unknown as IconType,
              iconPosition: 'right',
              wrapperComponent: Link,
              to: rightButton.url,
            }
          : undefined
      }
    />
  );
};
